import { getCurrentTimestamp, timestampToYYYYMMDDHHMMSS } from '../utils/date'
import { getData, postData } from './base-api'

// Global logger reference (will be set by index.js)
let globalLogger = null

// Function to set global logger from index.js
export const setGlobalLoggerInApi = (logger) => {
  globalLogger = logger
}

export const postAdRequest = async ({
  timestamp = getCurrentTimestamp(),
  resolve = () => {
    /* intentionally empty */
  },
  preload = () => {
    /* intentionally empty */
  },
  signal
}) => {
  preload(true)
  const urlParams = new URLSearchParams(window.location.search)
  try {
    const response = await postData(
      'api/ad-exchange/ad-request',
      {
        screenUuid: urlParams.get('screenUuid'),
        startTime: timestamp
      },
      signal
    )
    console.log('Ad Request successful:', response)
    resolve(response)
    return response
  } catch (error) {
    if (typeof error.message === 'string' && error.message.includes('AbortError')) {
      console.warn('Ad request aborted')
      return
    }
    console.error('Ad Request failed:', error)
  } finally {
    preload(false)
  }
}

export const sendPlaylog = async (adData) => {
  if (!adData) {
    console.warn('No ad data for playlog.')
    if (globalLogger) {
      await globalLogger.addEvent('sendPlaylog_no_data', {
        error_message: 'No ad data provided for playlog',
        screen_uuid: new URLSearchParams(window.location.search).get('screenUuid')
      })
    }
    return
  }

  const urlParams = new URLSearchParams(window.location.search)
  const postPayload = {
    screenUuid: urlParams.get('screenUuid'),
    messageError: '',
    sourceType: adData?.source?.type || 'filler',
    type: adData?.type || 'video',
    id: adData?.id,
    url: adData?.url,
    startPlay: timestampToYYYYMMDDHHMMSS(adData?.startTime * 1000),
    endPlay: timestampToYYYYMMDDHHMMSS((adData?.startTime + adData?.duration) * 1000),
    timestamp: adData?.startTime,
    duration: adData?.duration,
    adexchangeId: adData?.source?.adexchange_id,
    adexchangeCallback: adData?.source?.adexchange_callback,
    dealId: adData?.source?.deal_id || '',
    dealName: adData?.source?.deal_name || ''
  }

  try {
    const startTime = performance.now()
    await postData('api/ad-exchange/playlog', postPayload)
    const endTime = performance.now()

    // Log sendPlaylog SUCCESS
    if (globalLogger) {
      await globalLogger.addEvent('sendPlaylog_success', {
        adexchange_id: postPayload.adexchangeId,
        content_type: postPayload.type,
        source_type: postPayload.sourceType,
        duration_seconds: postPayload.duration,
        screen_uuid: postPayload.screenUuid,
        payload_size_bytes: JSON.stringify(postPayload).length,
        request_time_ms: endTime - startTime,
        deal_id: postPayload.dealId,
        deal_name: postPayload.dealName
      })
    }
  } catch (error) {
    console.error('Send Playlog failed:', error)

    // Log sendPlaylog FAILURE
    if (globalLogger) {
      await globalLogger.addEvent('sendPlaylog_failed', {
        error_message: error.message,
        error_stack: error.stack,
        error_type: error.constructor.name,
        adexchange_id: postPayload.adexchangeId,
        content_type: postPayload.type,
        source_type: postPayload.sourceType,
        screen_uuid: postPayload.screenUuid,
        payload_size_bytes: JSON.stringify(postPayload).length
      })
    }
  }
}

export const sendTrackingLog = async ({ adexchangeId, eventType, errorCode = null }) => {
  if (!adexchangeId || !eventType) {
    console.error('Missing adexchangeId or eventType for tracking log.')
    return false
  }

  try {
    let endpoint = `api/ad-exchange/tracking/event?adexchangeId=${adexchangeId}&eventType=${eventType}`

    // Add error-specific parameters if this is an error event
    if (eventType === 'error' && errorCode !== null) {
      endpoint += `&errorCode=${errorCode}`
    }

    await getData(endpoint)
    console.log(
      `Tracking log sent successfully: ${eventType}${errorCode ? ` (error ${errorCode})` : ''}`
    )

    return true
  } catch (error) {
    console.error('Send Tracking Log failed:', error)

    return false
  }
}
